import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer } from "react-toastify";
import Loader from "../components/Loader/Loader";
import { deleteDietTemplate, getAllDietTemplate, createDietPlanTemplate } from "../api/createDiet";
import { useNavigate } from 'react-router-dom';
import DietPlanTemplateModal from "../components/DietPlanTemplateModal/DietPlanTemplateModal";
import { Button } from "react-bootstrap";

const DietPlanTemplate = ({ onSubmit }) => {
    const [dietPlans, setDietPlans] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [expandedItems, setExpandedItems] = useState({}); // State to track expanded items
    const navigate = useNavigate();

    const handleDelete = (id) => {
        setIsLoading(true);
        deleteDietTemplate(id);
        setIsLoading(false);
        navigate(0);
    };

    const [showCreateModal, setShowCreateModal] = useState(false);

    const handleShow = () => setShowCreateModal(true);
    const handleClose = () => setShowCreateModal(false);

    const handleCreateSubmit = (payload) => {
        setIsLoading(true);
        createDietPlanTemplate(payload)
            .finally(() => {
                setIsLoading(false);
                handleClose();
            });
    };

    useEffect(() => {
        const getAllDietTemplateData = async () => {
            try {
                setIsLoading(true);
                const res = await getAllDietTemplate();
                setDietPlans(res);
            } catch (err) {
                console.log(err.message);
            } finally {
                setIsLoading(false);
            }
        };

        getAllDietTemplateData();
    }, [showCreateModal]);

    const toggleExpand = (id) => {
        setExpandedItems((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    if (isLoading) return <Loader></Loader>;

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h2>Templates</h2>
                <Button className="w-25" onClick={handleShow}>
                    Create Template
                </Button>
            </div>
            <>
                {dietPlans.length > 0 && dietPlans.map((item) => {
                    const isExpanded = expandedItems[item['_id']];
                    return (
                        item?.content?.length > 0 &&
                        <div key={item['_id']} style={{ display: 'flex', flexDirection: 'column', border: '0.5px solid black', padding: 10, margin: 20 }}>
                            <div>
                                <b>{item?.title}</b>
                                <div
                                    style={{
                                        maxHeight: isExpanded ? "none" : "100px", // Limit height when not expanded
                                        overflow: "hidden",
                                    }}
                                    dangerouslySetInnerHTML={{ __html: item.content[0] }}
                                />
                                <Button
                                    variant="link"
                                    onClick={() => toggleExpand(item['_id'])}
                                    style={{ padding: 0, marginTop: 5 }}
                                >
                                    {isExpanded ? "Show Less" : "Show More"}
                                </Button>
                            </div>
                            <i
                                className={"fa fa-trash fa-2x"}
                                onClick={() => handleDelete(item['_id'])}
                                style={{ alignSelf: "flex-end", cursor: "pointer" }}
                            ></i>
                        </div>
                    );
                })}
                {dietPlans.length === 0 && <div>{'No Templates created'}</div>}
            </>

            <DietPlanTemplateModal
                show={showCreateModal}
                handleClose={handleClose}
                handleSubmit={handleCreateSubmit}
            />
            <ToastContainer />
        </div>
    );
};

export default DietPlanTemplate;
